"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adEvents_1 = require("../../../types/sports/football/adEvents");
exports.footballAdEvents = [
    adEvents_1.FootballAdAllocationEvent.goal,
    adEvents_1.FootballAdAllocationEvent.redCard,
    adEvents_1.FootballAdAllocationEvent.yellowCard
];
//# sourceMappingURL=adEvents.js.map